<template>
  <div class="aside">
    <div class="menu">
      <!-- <h3>菜单</h3> -->
      <!-- <h3>Menu</h3> -->
      <ul>
        <li
          :class="{ active: $route.name === 'PoE2Standard' }"
          @click="navigateTo('/poe2-standard')"
        >
          <img src="@/assets/poe2icon.png" alt="PoE 2" class="menu-icon" />
          <!-- PoE 2-标准 -->
          <span>PoE 2 - Standard League</span>
        </li>
        <li
          :class="{ active: $route.name === 'PoE2Vaal' }"
          @click="navigateTo('/poe2-vaal')"
        >
          <img src="@/assets/poe2icon.png" alt="PoE 2" class="menu-icon" />
          <!-- PoE2-VAAL 赛季 -->
          <span>PoE 2 - Vaal League</span>
        </li>
        <li
          :class="{ active: $route.name === 'PoE1Home' }"
          @click="navigateTo('/poe1-home')"
        >
          <img src="@/assets/poeicon.png" alt="PoE 1" class="menu-icon" />
          <!-- PoE1-首页 -->
          <span>PoE 1 - Home Page</span>
        </li>
        <li
          :class="{ active: $route.name === 'PoE1Standard' }"
          @click="navigateTo('/poe1-standard')"
        >
          <img src="@/assets/poeicon.png" alt="PoE 1" class="menu-icon" />
          <!-- PoE1-标准 -->
          <span>PoE 1 - Standard League</span>
        </li>
        <li
          :class="{ active: $route.name === 'PoE1Keepers' }"
          @click="navigateTo('/poe1-keepers')"
        >
          <img src="@/assets/poeicon.png" alt="PoE 1" class="menu-icon" />
          <!-- PoE1-KEEPERS 赛季 -->
          <span>PoE 1 - Keepers League</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

const navigateTo = (path) => {
  router.push(path);
};
</script>

<style scoped>
.aside {
  position: fixed;
  top: 20px;
  right: calc((100vw - 1400px) / 2);
  width: 350px; /* 1400px 的 25% */
  /* height: 360px; */
  background: #1a1f28 linear-gradient(to right, #1a1f28, #101319);
  border: 1px solid #363636;
  border-radius: 8px;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.3);
  z-index: 100;
  overflow: hidden;
}

/* 当视口宽度小于容器最大宽度时，相应调整 */
@media (max-width: 1440px) {
  .aside {
    right: calc((100vw - 1200px) / 2);
    width: 300px; /* 1200px 的 25% */
  }
}

@media (max-width: 1280px) {
  .aside {
    right: calc((100vw - 1000px) / 2);
    width: 250px;
  }
}

@media (max-width: 1024px) {
  .aside {
    right: calc((100vw - 900px) / 2);
    width: 225px;
  }
}

@media (max-width: 900px) {
  .aside {
    right: 0;
    width: 25%;
  }
}

.menu {
  padding: 2px;
}

.menu h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #e0e0e0;
  padding-bottom: 10px;
  border-bottom: 2px solid #ff9f43;
}

.menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu li {
  position: relative;
  padding: 12px 16px;
  margin-bottom: 2px;
  background-color: transparent;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
  color: #ffc555;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-weight: 700;
  border: 1px solid transparent;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
}

/* 菜单项底部分割线 */
.menu li::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(to right, transparent 15%, #333 50%, transparent 85%);
  z-index: 1;
}

/* 最后一个菜单项不需要分割线 */
.menu li:last-child::before {
  display: none;
}

.menu-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
  flex-shrink: 0;
}

.menu li span {
  flex: 1;
  text-align: center;
}

.menu li:hover:not(.active) {
  background-color: transparent;
  color: #ffd98e;
  border-color: #ea683e;
}

.menu li.active {
  color: white;
  border-color: transparent;
  background: linear-gradient(
    to bottom,
    rgba(80, 20, 5, 0.5),
    rgba(210, 50, 20, 0.5)
  );
  border-radius: 5px;
}

/* 旋转边框动画 - 只在边框区域显示 */
.menu li.active::after {
  content: "";
  position: absolute;
  inset: -2px;
  border-radius: 5px;
  padding: 2px;
  background: conic-gradient(
    from var(--angle, 0deg),
    transparent 0deg,
    transparent 20deg,
    #ff6600 345deg,
    #ff8800 350deg,
    #ffaa00 355deg,
    #ff8800 357deg,
    #ff6600 360deg,
    transparent 360deg
  );
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  z-index: -1;
  animation: rotate 3s linear infinite;
}

@keyframes rotate {
  from {
    --angle: 0deg;
  }
  to {
    --angle: 360deg;
  }
}

@property --angle {
  syntax: "<angle>";
  initial-value: 0deg;
  inherits: false;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .aside {
    width: 40%;
  }
}
</style>
